<div class="sign-dialog">
  <h2 class="title">{{ translations.signContract }}</h2>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ translations.fullName }}</mat-label>
    <input matInput [formControl]="fullName" [placeholder]="translations.fullNamePlaceholder" (input)="onFullNameInput($event)" />
    @if (fullName.hasError('required') && fullName.touched) {
      <mat-error>{{ translations.fullNameRequired }}</mat-error>
    }
    @if (fullName.hasError('minlength') && fullName.touched) {
      <mat-error>{{ translations.fullNameMinLength }}</mat-error>
    }
  </mat-form-field>

  <div class="canvas-wrap">
    <div class="canvas-label">{{ translations.signature }}</div>
    <canvas #sigCanvas class="sig-canvas" aria-label="Signature pad"></canvas>
    <div class="hint">{{ translations.drawSignatureAbove }}</div>
  </div>

  <div class="actions">
    <button mat-button class="grey-btn" type="button" (click)="close()">{{ translations.close }}</button>
    <button mat-button class="grey-btn" type="button" (click)="clear()">{{ translations.clear }}</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!canSubmit" (click)="save()">{{ translations.submit }}</button>
  </div>
</div>

